import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { Observable, Subject, Subscription } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserInteractionOutcome } from '@nimbus-library/features/agent-assistant/models/agent-assistant.model';
import { AgentAssistantRonaService } from '@nimbus-library/features/agent-assistant/services/agent-assistant-rona.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { UserTaskStateService } from '@nimbus-library/features/user-state/services/user-task-state.service';
import { BackgroundTaskFactory } from '@nimbus-library/features/background-task/background-task.factory';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'nimbus-rona-state',
  templateUrl: './rona-state.component.html',
  styleUrls: ['./rona-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RonaStateComponent implements OnInit, OnDestroy {
  private readonly subscription$ = new Subscription();
  private stopEventTrigger$: Subject<boolean> = new Subject();

  public TranslationKeys = TranslationKeys;
  public Icons = ICONS;
  public UserInteractionOutcome = UserInteractionOutcome;

  public stopDisabled$: Observable<boolean>;

  public baseDate$: Observable<moment.Moment>;
  public ronaStartedAt$: Observable<string | null>;

  public constructor(
    private readonly backgroundTaskFactory: BackgroundTaskFactory,
    private readonly authenticationService: IAuthenticationService,
    private readonly userTaskStateService: UserTaskStateService,
    private readonly agentAssistantRonaService: AgentAssistantRonaService,
  ) {}

  public ngOnInit(): void {
    this.baseDate$ = this.backgroundTaskFactory.getServerWatches();
    this.ronaStartedAt$ = this.userTaskStateService.getRonaStartedAt$();

    this.stopDisabled$ = this.stopEventTrigger$.asObservable();

    this.subscription$.add(
      this.ronaStartedAt$.pipe(untilDestroyed(this)).subscribe(() => {
        this.stopEventTrigger$.next(false);
      }),
    );
  }

  public stop(): void {
    const userId = this.authenticationService.getUserInfo().userId;
    this.stopEventTrigger$.next(true);
    this.subscription$.add(this.agentAssistantRonaService.stopRona(userId).pipe(untilDestroyed(this)).subscribe());
  }

  public ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
